import { Service } from '@roc/feature-app-core';

const url = {
  UPDATE_TITLE_AGENT_FORM_V2: '/nportal/rest/priv/loanDocs/updateTitleAgentFormV2',
  GET_TITLE_AGENCY_BY_ID: '/nportal/rest/priv/loanForeclosure/getTitleAgencyById',
  GET_ALL_TITLE_AGENCIES: '/nportal/rest/priv/loanForeclosure/getAllTitleAgencies',
  UPDATE_REALIZED_PRINCIPAL_AND_INTEREST_LOSS: '/nportal/rest/priv/loanDocs/updateRealizedPrincipalAndInterestLoss',
  UPDATE_DELINQUENCY_STATUS_AND_COMMENTS: '/nportal/rest/priv/loanDocs/updateDelinquencyStatusAndComments',
  SAVE_CUSTOM_FIELD: '/nportal/rest/priv/customFields/saveCustomField',
  SAVE_PROPERTY_LIST: '/nportal/rest/priv/property/savePropertyList',
  UPDATE_FORECLOSURE_ATTORNEY_FORM_V2: '/nportal/rest/priv/loanDocs/updateForeclosureAttorneyFormV2',
};

export type TitleAgency = {
  titleAgencyId: number;
  name: string;
};

export type InterestAndPrincipalLoss = {
  loanId: number,
  interestLoss: number,
  principalLoss: number,
};

export type TitleAgencyDetail = {
  titleAgencyId?: number;
  name?: string;
  alias?: string;
  email?: string;
  phone?: string;
  state?: string;
};

export type UpdateTitleAgentFormV2Body = {
  titleAgencyId: number;
};

export type UpdateForeclosureAttorneyFormV2Body = {
  foreclosureAttorneyId?: number;
  investorAttorneyId?: number;
};

export type UpdateDelinquencyStatusAndCommentsBody = {
  loanId: number;
  delinquencyComments: string;
  delinquencyStatus: string;
  delinquencySubStatus: string;
  delinquencyStatusComment: string;
};

export class DelinquencyService extends Service {
  updateTitleAgentFormV2(loanId: number, requestBody: UpdateTitleAgentFormV2Body) {
    return this.post(
      `${url.UPDATE_TITLE_AGENT_FORM_V2}?loanId=${loanId}`,
      requestBody
    );
  }

  getTitleAgencyById(titleAgencyId: number) {
    return this.get(url.GET_TITLE_AGENCY_BY_ID, { titleAgencyId });
  }

  getTitleAgencyList() {
    return this.get(url.GET_ALL_TITLE_AGENCIES);
  }

  setRealizedPrincipalAndInterestLoss(requestBody: InterestAndPrincipalLoss) {
    return this.put(url.UPDATE_REALIZED_PRINCIPAL_AND_INTEREST_LOSS, requestBody);
  }

  updateDelinquencyStatusAndComments(
    requestBody: UpdateDelinquencyStatusAndCommentsBody
  ) {
    return this.put(url.UPDATE_DELINQUENCY_STATUS_AND_COMMENTS, requestBody);
  }

  saveCustomField(loanId: string, field: string, value: string) {
    const query = `loanId=${loanId}&field=${encodeURIComponent(field)}&value=${encodeURIComponent(value)}`;
    return this.post(`${url.SAVE_CUSTOM_FIELD}?${query}`, {});
  }

  updatePostApprovalPropertyAppraisals(properties: Record<string, unknown>[]) {
    return this.post(url.SAVE_PROPERTY_LIST, properties);
  }

  updateForeclosureAttorneyFormV2(
    loanId: string,
    requestBody: UpdateForeclosureAttorneyFormV2Body
  ) {
    return this.post(
      `${url.UPDATE_FORECLOSURE_ATTORNEY_FORM_V2}?loanId=${loanId}`,
      requestBody
    );
  }
}

export const delinquencyService = new DelinquencyService();
